<template>
  <div class="message-queues-targets">
    <div class="mb-x2" layout layout-align="space-between-start">
      <el-button type="default" @click="changeTab('queue-list')"
        ><i class="mdi mdi-keyboard-backspace"></i>一覧に戻る</el-button
      >
      <csv-download :disabled="!messages.length || is_download" :download="downloadCsv"></csv-download>
    </div>
    <el-table
      class="mb-x2"
      v-loading="loading"
      :data="messages"
      stripe
      empty-text="データがありません。"
      style="width: 100%"
    >
      <el-table-column label="ステータス" min-width="30%">
        <template slot-scope="scope">
          <div class="text-info" v-if="status === 'scheduled'">スケジュール済み</div>
          <div class="text-disabled" v-if="status === 'draft'">下書き</div>
        </template>
      </el-table-column>
      <el-table-column label="宛先アカウント" min-width="70%">
        <template slot-scope="scope">
          <applicant-name :applicant="scope.row"></applicant-name>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-if="messages.length" :total="total"></pagination>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import ApplicantName from '@/client/components/_atoms/applicant_name'
import CsvDownload from '@/client/components/_atoms/csv_download'
import Pagination from '@/client/components/_atoms/pagination'
import api from '@/client/core/api'
import { useTwitterInstantwinMessageStore } from '@/client/store/useTwitterInstantwinMessageStore'
import { useTwitterInstantwinQueueStore } from '@/client/store/useTwitterInstantwinQueueStore'

export default defineComponent({
  components: {
    ApplicantName,
    CsvDownload,
    Pagination
  },
  data() {
    return {
      messages: [],
      loading: false,
      is_download: false,
      total: 0,
      messageId: null,
      status: null
    }
  },
  computed: {
    ...mapState(useTwitterInstantwinMessageStore, {
      campaignId: state => state.campaign.id
    }),

    ...mapState(useTwitterInstantwinQueueStore, {
      queueId: state => state.queueMessages.queueId
    })
  },
  async mounted() {
    if (this.queueId) {
      await this.getMessageQueueById()
      await this.getMessageTargets()
    }
  },
  methods: {
    /**
     * メッセージを取得
     */
    async getMessageQueueById() {
      const queue = await api.get(`/twitter_instantwin_queues/${this.queueId}`)

      if (!queue || !queue.data) {
        return
      }

      const { status, messageId } = queue.data
      this.messageId = messageId
      this.status = status
    },

    /**
     * 配信対象を取得
     */
    async getMessageTargets() {
      this.loading = true
      const params: any = { campaignId: this.campaignId }

      if (this.messageId) {
        params.messageId = this.messageId
      }

      const result = await api.get(`/twitter_instantwin_queues/targets/${this.queueId}`, { params })
      this.loading = false

      if (!result.data) {
        this.messages = []
        this.total = 0
        return
      }

      this.messages = result.data
      this.total = result.data.length
    },

    /**
     * Change screen
     * @param {string} tab
     */
    changeTab(tab: string) {
      this.$emit('change_tab', tab)
    },

    /**
     * CSVダウンロード
     */
    async downloadCsv() {
      this.is_download = true

      const params: any = { campaignId: this.campaignId }

      if (this.messageId) {
        params.messageId = this.messageId
      }

      const result = await api.get(`/twitter_instantwin_queues/targets/${this.queueId}`, { params })

      this.is_download = false

      if (!result.data) {
        this.$notify({
          title: 'CSVダウンロードに失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      const messages = result.data
      const filename = `instantwin_message_target_${moment().format('YYYY_MM_DD')}`
      const csvData = []
      csvData.push(['ステータス', 'アカウント名', 'アカウントスクリーンネーム', 'アカウント画像'])

      const status = this.status === 'scheduled' ? 'スケジュール済み' : '下書き'

      // CSVデータを格納
      messages.forEach(message => {
        csvData.push([status, message.name, message.screenName, message.pictureUrl])
      })

      return {
        filename,
        data: csvData
      }
    }
  }
})
</script>
